export const shared = {
  invalidLinkMissingParams: 'Invalid link. Missing parameters.',
  errorLoadingDocument: 'Error occurred while loading the document.',
  passwordProtected: 'Password protected document',
  enterPassword: 'This document is password protected. Please enter the password to view it.',
  password: 'Password',
  viewDocument: 'View document',
  invalidPassword: 'Invalid password.',
  incorrectPasswordTryAgain: 'Incorrect password. Please try again.',
  download: 'Download',
  captchaRequired: 'Please verify that you are not a robot.',
  captchaError: 'Error occurred while verifying the robot.',
  captchaExpired: 'The verification has expired. Please verify again that you are not a robot.',
  captchaVerificationFailed: 'The robot verification failed. Please try again.'
}
